import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

enum FancyKeys {
  Left = '←',
  Right = '→',
  Up = '↑',
  Down = '↓',
  Command = '⌘'
}

@Component({
  selector: 'app-view-shortcuts',
  templateUrl: './view-shortcuts.component.html',
  styleUrls: ['./view-shortcuts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewShortcutsComponent implements OnInit {
  readonly shortcutGroups = [
    {
      label: 'Navigation',
      shortcuts: [
        {
          keys: [',', 'Pg-Up'],
          label: 'Previous chapter'
        },
        {
          keys: ['.', 'Pg-Down'],
          label: 'Next chapter'
        },
        {
          keys: ['/'],
          label: 'Open Search'
        },
        {
          keys: ['Ctrl + Enter'],
          label: 'Enter Fullscreen'
        },
        {
          keys: ['Ctrl/Cmd + ,'],
          label: 'Toggle Description'
        }
      ]
    },

    {
      label: 'Tools',
      shortcuts: [
        {
          keys: ['1'],
          label: 'Use "Select" tool'
        },
        {
          keys: ['2'],
          label: 'Use "Hide" tool'
        },
        {
          keys: ['3'],
          label: 'Use "Fade" tool'
        },
        {
          keys: ['del', 'backspace'],
          label: 'Hide selected structure'
        },
        {
          keys: ['Shift + R'],
          label: 'Reset chapter'
        },
        {
          keys: ['Ctrl/Cmd + Z'],
          label: 'Undo'
        },
        {
          keys: ['Ctrl/Cmd + Shift + Z', 'Ctrl/Cmd + Y'],
          label: 'Redo'
        }
      ]
    },

    {
      label: 'Pan',
      shortcuts: [
        {
          keys: ['W'],
          label: 'Pan up'
        },
        {
          keys: ['S'],
          label: 'Pan down'
        },
        {
          keys: ['A'],
          label: 'Pan left'
        },
        {
          keys: ['D'],
          label: 'Pan right'
        },
        {
          keys: ['Shift + W'],
          label: 'Slow pan up'
        },
        {
          keys: ['Shift + S'],
          label: 'Slow pan down'
        },
        {
          keys: ['Shift + A'],
          label: 'Slow pan left'
        },
        {
          keys: ['Shift + D'],
          label: 'Slow pan right'
        }
      ]
    },

    {
      label: 'Rotate',
      shortcuts: [
        {
          keys: [FancyKeys.Up],
          label: 'Rotate up'
        },
        {
          keys: [FancyKeys.Down],
          label: 'Rotate down'
        },
        {
          keys: [FancyKeys.Left],
          label: 'Rotate left'
        },
        {
          keys: [FancyKeys.Right],
          label: 'Rotate right'
        },
        {
          keys: [`Shift + ${FancyKeys.Up}`],
          label: 'Slow rotate up'
        },
        {
          keys: [`Shift + ${FancyKeys.Down}`],
          label: 'Slow rotate down'
        },
        {
          keys: [`Shift + ${FancyKeys.Left}`],
          label: 'Slow rotate left'
        },
        {
          keys: [`Shift + ${FancyKeys.Right}`],
          label: 'Slow rotate right'
        }
      ]
    },

    {
      label: 'Zoom',
      shortcuts: [
        {
          keys: ['C', '='],
          label: 'Zoom in'
        },
        {
          keys: ['E', '-'],
          label: 'Zoom out'
        },
        {
          keys: ['Shift + C', 'Shift + ='],
          label: 'Slow zoom in'
        },
        {
          keys: ['Shift + E', 'Shift + -'],
          label: 'Slow zoom out'
        }
      ]
    }
];


  constructor() { }

  ngOnInit() {
  }

}
